module.exports = __webpack_public_path__ + "static/closeup-7b45610d512e00a5e699501a52254698.jpg";